"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function Caret(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "caret-".concat(props.direction)
  });
}

Caret.propTypes = {
  direction: _propTypes.default.oneOf(['raise', 'drop', 'left', 'right'])
};
var _default = Caret;
exports.default = _default;
//# sourceMappingURL=Caret.js.map